<template>
  <div :class="ui.bkgdColor">
      <v-layout class="text-xs-right mt-2 mr-2">
        <v-spacer/>
        <v-btn :color="ui.textSubheading"
        :disabled="getAnalysisList.length > 30"
        flat icon @click="openDialog()">
          <v-icon :color="ui.btnColor"> add </v-icon>
        </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor" :text-color="ui.bkgdColor">
          <v-card-title class="title wplblue0--text">
            New Analysis
          </v-card-title>
          <v-progress-linear color="blue-grey" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm8>
                  <v-text-field
                  v-model="localForm.title"
                  label="failure name"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="title"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.type"
                  :items="analysisTypeOptions"
                  label="type"
                  :rules="ruleMustBeSelected"
                  prepend-icon="grid_view"
                  hint="part type"
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.id"
                  label="failure id"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="fingerprint"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                  v-model="localForm.dis"
                  :items="engineeringDiscipline"
                  label="discipline"
                  prepend-icon="engineering"
                  hint="discipline"
                  required
                  >
                </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.cause"
                  :items="analysisCauseOptions"
                  label="cause"
                  prepend-icon="adjust"
                  hint="source"
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.effect"
                  :items="analysisEffectOptions"
                  label="effect"
                  prepend-icon="warning"
                  hint="effect"
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.detect"
                  :items="analysisDetectOptions"
                  label="detect"
                  prepend-icon="straighten"
                  hint="detects"
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.cond"
                  label="condition"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="manage_history"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.patt"
                  :items="analysisPatternOptions"
                  label="rate"
                  prepend-icon="scatter_plot"
                  hint="/10^6 "
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.rate"
                  label="failure rate"
                  :rules="mustBeLessThanSmallNotRequired"
                  prepend-icon="running_with_errors"
                  hint="rel. units"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4 mb-2">
                  Failure Mode Analysis
                </div>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localForm.com"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="ruleMustBeNotUndefinedANDLessThan1000"
                  hint="failures and rates without maintenance plan"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" color="wplblue0" flat>
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
            <v-spacer/>
            <v-btn @click="validate" color="wplblue0" flat
            >
              <v-icon left> add </v-icon>
              add
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import master from "@/data/forms/mixins/master.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import analysisOptions from "@/data/options/mixins/analysisOptions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    techOptions,
    listFunctions,
    generateForms,
    master,
    analysisOptions,
    rulesTextfield,
    uisettings,
    generateID,
    docRevsModFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getAnalysisList",
      "getAnalysisListCounter",
      "getDetail",
      "getUser"
    ]),
    ui() {
      return this.uiTheme1;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      localForm: {
        id: "", // parts Id
        title: "", // parts title
        dis: "", // eng. discipline
        com: "", // parts comments
        cause: "Human", // parts
        detect: "", // hell
        effect: "",
        rate: "",
        patt: "Age", // pattern
        type: "FM", // type
        status: ""
      }
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
      // this.$store.dispatch("changeAnalysisList", []);
      // this.$refs.form.reset();
    },
    validate() {
      // cosole.log(this.taskForm)
      // this.$refs.form.validate() === true
      if (this.$refs.form.validate() === true) {
        // NEW ANALYSIS
        let tempForm = this.generateAnalysisForm();
        tempForm.basic.idg = this.generateIDG("date-gid");
        tempForm.basic.did = this.generateDID("DATE", "E3");
        tempForm.basic.idi = this.getAnalysisListCounter + 1;
        tempForm.basic.title = this.localForm.title;
        tempForm.basic.id = this.localForm.id;
        tempForm.basic.tag = "E3";
        // CHAR
        tempForm.char.type = this.localForm.type;
        tempForm.char.dis = this.localForm.dis;
        tempForm.char.cause = this.localForm.cause;
        tempForm.char.com = this.localForm.com;
        tempForm.char.effect = this.localForm.effect;
        tempForm.char.patt = this.localForm.patt;
        tempForm.char.rate = this.localForm.rate;
        tempForm.char.cond = this.localForm.cond;
        tempForm.char.detect = this.localForm.detect;
        // STATS
        tempForm.stats.dcrt = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        var tempList = this.getAnalysisList;
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.appendItemLimited(parseobj, tempList, 50);

        // STORE UPDATE
        this.$store.dispatch("changeAnalysisList", newList);
        this.$store.dispatch("changeAnalysisListCounter", tempForm.basic.idi);
        this.saveDocumentRevMod(5.11, 1); // attachment added.
        this.$store.dispatch("changeDataSavePendingIndication", true);

        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
